import { styled } from "@linaria/react"

export const SecondaryTextSpan = styled.span`
  color: var(--secondary-text-color)
`